import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import React from 'react';
import FunctionsContext from './FunctionsContext';


const AddFunction = props => {
    return (
        <FunctionsContext.Consumer>
            {context =>
                <Dialog open={context.addFunctionModalOpen} onClose={() => context.closeAddFunction()}>

                    <DialogTitle>Add Function</DialogTitle>

                    <DialogContent>
                        <DialogContentText>
                            Please enter function details:
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={ () => {context.closeAddFunction()} }>Cancel</Button>
                        <Button>Submit</Button>
                    </DialogActions>

                </Dialog>
            }
        </FunctionsContext.Consumer>
    );
}

export default AddFunction;